import request from '@/utils/request'

// 上传报告
export function companyRepo(data) {
    console.log("data", data)
    return request({
        url: "https://8.138.185.207:4091/chat/xcChat/companyRepo",
        method: 'post',
        data
    })
}

// 获取历史对话
export function getHistoryList(openId) {
  return request({
    url: "https://aiapi.xchengtech.cn/history/getHistoryList/" + openId,
    method: 'get',
  })
}

// 获取历史对话的内容
export function getUserConversation(openId,questionId) {
  return request({
    url: "https://aiapi.xchengtech.cn/history/getUserConversation/" + openId + "/" + questionId,
    method: 'get',
  })
}


export function getPolicyObj() {
  return request({
    url: 'https://api.xchengtech.cn/cus/getPolicyObj/nnn123',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/robot.js